import React from "react";
import "./portfolio.css";
import PortfolioCard from "./PortfolioCard";
import IMG1 from "../../assets/portfolio0.png";
import IMG2 from "../../assets/portfolio1.png";
import IMG3 from "../../assets/portfolio2.png";
import IMG4 from "../../assets/portfolio3.png";
import IMG5 from "../../assets/portfolio4.png";
import IMG6 from "../../assets/portfolio5.png";

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>A Sample of My Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        <PortfolioCard
          title="Bee Happy : A challenging mobile game! (100% Original design)"
          gitLink="https://github.com"
          demoLink="https://play.google.com/store/apps/details?id=com.ToyChan.BeeHappy"
          image={IMG1}
          disabled="disabled"
        />
        <PortfolioCard
          title="Responsive Calculator App!"
          gitLink="https://github.com/theintelligentguy/calculator"
          demoLink="https://toy-chan.com/projects/calculator"
          image={IMG2}
        />
        <PortfolioCard
          title="Day to day TODO list App!"
          gitLink="https://github.com"
          demoLink="https://toy-chan.com/projects/list"
          image={IMG3}
          disabled="disabled"
        />
        <PortfolioCard
          title="An image search App!"
          gitLink="https://github.com"
          demoLink="https://toy-chan.com/projects/imagesearch"
          image={IMG4}
          disabled="disabled"
        />
        <PortfolioCard
          title="Youtube Proxy App!"
          gitLink="https://github.com"
          demoLink="https://toy-chan.com/projects/youtube"
          image={IMG5}
          disabled="disabled"
        />
        <PortfolioCard
          title="The Mathematician Game: Guess the right answer!"
          gitLink="https://github.com"
          demoLink="https://toy-chan.com/projects/mathgame"
          image={IMG6}
          disabled="disabled"
        />
      </div>
      <h5 className="portfolio__bottom">
        Want to see more complex{" "}
        <a href="#contact" style={{ color: "rgb(13, 162, 3)" }}>
          projects
        </a>
        ?
      </h5>
    </section>
  );
};

export default Portfolio;
